export default __webpack_public_path__ + "a5ce326b40be3461f37fb1b340b0621f.png";